import axios from 'axios';
import { Auth } from 'aws-amplify';

const instance = axios.create();

instance.interceptors.request.use(
  async config => {
    try {
      const session = await Auth.currentSession();
      const token = session.getIdToken().getJwtToken();
      config.headers.Authorization = `Bearer ${token}`;
    } catch (error) {
      // No session available
    }
    return config;
  },
  error => Promise.reject(error)
);

export default instance;
